module.exports = __webpack_public_path__ + "static/media/cannabis.4cbefa59.svg";